import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, extractError } from '@/lib/api.js';

/** D-RF-13 — ferramenta pública limitada + captura de lead (tier LEAD via HAOps). */
export function LeadMagnetPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await api.post('/webhooks/public/lead', { email, name: name || undefined });
      setOk(true);
    } catch (ex) {
      setErr(extractError(ex).message);
    }
  }

  if (ok) {
    return (
      <div className="mx-auto max-w-md px-4 py-16 text-center">
        <h1 className="mb-4 text-2xl font-black">Obrigado!</h1>
        <p className="mb-6 text-ha-subtle">Enviamos seu acesso ao diagnóstico em breve.</p>
        <button
          type="button"
          className="py-3 text-[10px] font-bold uppercase text-black"
          style={{ background: 'linear-gradient(135deg,#ffc800,#ffe47a)' }}
          onClick={() => nav('/cadastro')}
        >
          Criar conta agora
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="mb-2 text-2xl font-black">
        Diagnóstico <span className="text-accent">grátis</span>
      </h1>
      <p className="mb-8 text-sm text-ha-subtle">
        As 5 Forças do Crescimento — versão limitada para leads. Informe seu e-mail para liberar.
      </p>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <input
          className="border border-ha-border2 bg-ha-card2 px-4 py-3 text-sm"
          placeholder="Seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          required
          className="border border-ha-border2 bg-ha-card2 px-4 py-3 text-sm"
          placeholder="E-mail corporativo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {err && <p className="text-sm text-feedback">{err}</p>}
        <button
          type="submit"
          className="py-4 text-[11px] font-extrabold uppercase tracking-[2px] text-black"
          style={{ background: 'linear-gradient(135deg,#ffc800,#ffe47a,#e6a800)' }}
        >
          Liberar diagnóstico
        </button>
      </form>
      <p className="mt-6 text-center text-xs text-ha-muted">
        Já tem conta? <Link to="/login" className="underline">Entrar</Link>
      </p>
    </div>
  );
}
